export const environment = {

	production: false,
	local: false,

	baseUrl: 'https://api-qat.mss.ford.com',
	baseBulkOrderCreationUrl: '/wersbulkordercreation',
	commitmentUrl: '/WholesaleCommitmentService',
	wholesaleAllocationUrl: '/wholesaleallocationservice',
	dealerServiceUrl: '/dealerdetails',
	wersWholesaleAllocationUrl: '/werswholesaleallocation',
	
	redirectUrl_i: 'https://wwwqa.gws.ford.com',
	redirectUrl_e: 'https://wwwqa.gws.ford.com',

	saveVolumeCommitUrl: '/web/v1/volume-level-commitment',
	getAllVolumeCommitUrl: '/web/v1/vehicleline-volume-commitment',
	getWholesaleStatusUrl: '/web/v1/wholesaleStatus',
	getDealerDetailsUrl: '/web/v1/dealer-volume-commitment',
	getDealerGroupsUrl: '/web/v1/dealer-groups',
	getProductionOfferUrl: '/web/v1/get-production-offers',
	getDealerDetailUrl: '/web/v1/get-dealer-details',
	getDealerIdlistUrl: '/web/v1/dealer-ids',
	postEmailServiceUrl: '/web/v1/send-message',
	getDistrictAndZoneListUrl: '/web/v1/market-districts-zones',
	getMessageUrl: '/web/v1/message-broadcast',
	getVolumeCommitDataForAudit: '/web/v1/volume-commitment-by-market',
	getMarketListUrl: '/web/v1/get-market-list',
	getdealerViewListUrl: '/web/v1/get-dealer-view-list',
	getMarketLanguageMappingListUrl : '/web/v1/get-market-language-mapping-list',
    getMulitpleMarketUsersListUrl : '/web/v1/get-multiple-market-users-list',
    getSwitzerlandi18nUrl : '/web/v1/get-switzerland-i18n-list',
    getZoneManagerMailidListUrl : '/web/v1/get-zone-manager-mail-id-list',
	updateLogoutUrl: '/web/v1/updateLogoutTokenStatus',
	getDealerEntityMixUrl: '/web/v1/getDealerEntityMix',
	saveDealerEntityMixUrl: '/web/v1/saveDealerEntityMix',
	getProductionOfferEntitiesUrl: '/web/v1/get-production-offer-entities',

	openidUrl: 'https://corpqa.sts.ford.com/adfs/oauth2/authorize',
	openidClientId: 'urn:globalwholesalewebui:clientid:web_gwsdevwebsite:qa',
	openidResource: 'urn:globalwholesalewebui:resource:web_gwsdevwebsite:qa',

	// MSAL Configuration - structured like reference project
	msalConfig: {
		auth: {
			clientId: '55615286-65a2-4ad9-b06f-f69c84ea1fae',
			authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0'
		}
	},
	apiConfig: {
		scopes: [
			'api://b597d4c1-16b6-4db6-aed2-5d6a2cd908ea/.default'
		],
		uri: 'https://api-qat.mss.ford.com/'
	}
};
